/**
 * Jerf — Holly Constants
 *
 * Projede kullanılacak sabitler, API endpointleri ve yardımcı fonksiyonlar.
 * Kullanılmayan endpointleri/blokları silin, yenisini eklerken buraya ekleyin.
 */

const BRIDGE_BASE_URL = "/apps/apibridge/integration/path/";

const HC_API = {
    SEND_CALLME_FORM: "/apps/hollyconnect/Form/submit",
    GET_STORES: "/apps/hollyconnect/bff/get-store-list",
    GET_STORE: "/apps/hollyconnect/bff/get-store",
};

// Regex patterns
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,}$/;

// Telefon alanında varsayılan seçili ülke (holly-phone-input snippet'i kullanır)
const MAIN_COUNTRY_ISO_CODE = "tr";

/**
 * ApiBridge cevabındaki gövdeyi (body) parse ederek döner.
 * @param {object} response ApiBridge cevabı
 * @returns {object|null} Parse edilmiş gövde, aksi halde null
 */
function getBodyFromApiBridgeResponse(response) {
    try {
        if (response && response.data) {
            if (response.data.status === 200 && response.data.body) {
                return JSON.parse(response.data.body);
            } else if (response.data.status === 404) {
                return response.data;
            }
        }
        return null;
    } catch (error) {
        return null;
    }
}
